import React, { Component } from 'react';
import Popup from 'reactjs-popup';

import { CardRadio } from "./common/CardRadio"
import assessmentScorecards from '../images/USRSB_Original_Logo_4C.png'
import './styles/industry.css';

export class Industry extends Component {

    onClick = (id) => {
        this.props.updateSelectedOption(id)
    }
    render() {
        let options;
        const Card = ({ title }) => (
            <div className="disclaimer-card">
                <div className="disclaimer-header">{title} </div>
                <div className="disclaimer-content">
                    <p>This Self Assessment Tool (the 'Tool') provides individuals throughout the beef value chain an opportunity to evaluate their own operations against the sustainability indicators that the US Roundtable for Sustainable Beef ('USRSB') has identified.
                     The Tool is for educational purposes only, as it educates users on the indicators that make up sustainability, how such indicators can be used to assess a user's business progress, and how to compare such progress from year to year.
                        The USRSB, the Noble Research Institute, and The Samuel Roberts Noble Foundation are not bound by and shall not be responsible for any results generated by the Tool. The USRSB, the Noble Research Institute,
                        The Samuel Roberts Noble Foundation, and any directors, officers, employees, or agents thereof are not liable for any damages of any kind, including, but not limited to, consequential, indirect, punitive, exemplary, special,
                        or incidental damages, which may result from use of the Tool or reliance upon any results generated by the Tool.
                    </p>
                    <p>The USRSB only records users' supply chain sector and geographic location from the Tool; no other information provided by users is recorded by the USRSB.
                        USRSB uses the recorded information to evaluate and modify the Tool. At the end of the Self Assessment, a downloadable summary page will be available that a user can save on his or her own computer.
                    </p>
                    <p>For more information about each question, the Tool provides links that lead to existing resources on the indicators. For any other questions, please email [EMAIL ADDRESS].
                    </p>
                    <p>By accessing or using the Tool, you hereby agree to the terms of this Disclaimer.</p>
                </div>
            </div>
        )
        return (
            <div className="panel panel-default main-panel" >
                <div className="panel-heading">
                    <Popup
                        trigger={<a><i className="glyphicon glyphicon-info-sign"></i> Using the Assessment</a>}
                        on="click"
                        position="right top"
                        closeOnDocumentClick>
                        <Card title="Disclaimer" />
                    </Popup>
                    <a href="https://www.noble.org/privacy-notice/" className="pull-right">Privacy Notice</a>
                </div>
                <div className="panel-body main-body">
                    <div className="row">
                        <div className="col-xs-10 col-xs-offset-1">
                            <img src={assessmentScorecards} className="section-image"
                            />
                        </div>
                        <div className="col-xs-11 col-xs-offset-1">
                            <span className="SectionTitle">Please select your industry</span>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-sm-5 col-sm-offset-1 selection-top">
                            <CardRadio
                                label={this.props.state.IndustryData[0].description}
                                onClick={this.onClick}
                                id="1"
                                optionClass="IndustryOption"
                                CardStyle="OptionCard"
                            />
                        </div>
                        <div className="col-sm-5">
                            <CardRadio
                                label={this.props.state.IndustryData[1].description}
                                onClick={this.onClick}
                                id="2"
                                optionClass="IndustryOption"
                                CardStyle="OptionCard"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5 col-sm-offset-1">
                            <CardRadio
                                label={this.props.state.IndustryData[2].description}
                                onClick={this.onClick}
                                id="3"
                                optionClass="IndustryOption"
                                CardStyle="OptionCard"
                            />
                        </div>
                        <div className="col-sm-5">
                            <CardRadio
                                label={this.props.state.IndustryData[3].description}
                                onClick={this.onClick}
                                id="4"
                                optionClass="IndustryOption"
                                CardStyle="OptionCard"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5  col-sm-offset-1 selection-bottom">
                            <CardRadio
                                label={this.props.state.IndustryData[4].description}
                                onClick={this.onClick}
                                id="5"
                                optionClass="IndustryOption"
                                CardStyle="OptionCard"
                            />
                        </div>
                    </div>
                   
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Industry.js